import { useMemo } from "react"
import { useSelector } from "react-redux"
import { selectLoggedInArtistID } from "../store/auth/authSelector"
import { selectArtistMap } from "../store/common/commonSelector"
import { STUDIO_FALLBACK_LOCALE } from "../models/studio"
import { loadArtistLocale, saveArtistLocale } from "../api/localArtistPersistence"

export const useLoggedInArtistLocale = () => {
    const loggedInArtistId = useSelector(state => selectLoggedInArtistID(state))
    const artistMap = useSelector(state => selectArtistMap(state))
    const locale = useMemo(() => {
        if (!loggedInArtistId) {
            return STUDIO_FALLBACK_LOCALE
        }

        const storedLocale = loadArtistLocale(loggedInArtistId)
        const mapLocale = artistMap && artistMap[loggedInArtistId]?.locale

        if (mapLocale) {
            if (storedLocale !== mapLocale) {
                saveArtistLocale(loggedInArtistId, mapLocale)
            }
            return mapLocale
        }
        return storedLocale || STUDIO_FALLBACK_LOCALE
    }, [artistMap, loggedInArtistId])
    return locale
}